import { PostWithDetails } from '../models';
import { PostRepository } from '../repositories';

export class GetTournamentPostsUseCase {
  constructor(private postRepository: PostRepository) {}

  async execute(tournamentId: string, requestingUserId: string, limit: number = 20, offset: number = 0): Promise<PostWithDetails[]> {
    const posts = await this.postRepository.getTournamentPosts(tournamentId, requestingUserId, limit, offset);
    return posts;
  }
}
